import script from "./VoucherCartItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./VoucherCartItem.vue?vue&type=script&setup=true&lang=ts"

import "./VoucherCartItem.vue?vue&type=style&index=0&id=2e1cfbba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e1cfbba"]])

export default __exports__